import { useState } from "react";
import { dataverseClient } from "../services/dataverseClient";
import { OutlookMailItem } from "../services/outlookService";

export function useFileEmail() {
  const [filing, setFiling] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fileEmail = async (
    mailItem: OutlookMailItem,
    regardingId?: string,
    regardingType?: string
  ) => {
    setFiling(true);
    setError(null);
    setSuccess(false);

    try {
      await dataverseClient.createEmailActivity({
        subject: mailItem.subject,
        description: mailItem.body,
        senderEmail: mailItem.senderEmail,
        recipientEmails: mailItem.recipientEmails,
        regardingObjectId: regardingId,
        regardingObjectType: regardingType,
      });
      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Failed to file email"));
    } finally {
      setFiling(false);
    }
  };

  return { fileEmail, filing, success, error };
}
